<template>
  <div data-app>
    <div class="uk-card uk-card-default uk-animation-fade" style="min-height: calc(100vh - 30px);">
      <!--шапка-->
      <div class="uk-card-header">
        <div class="uk-grid uk-flex-middle" data-uk-grid>
          <div class="uk-width-auto">
            <div class="uk-card-title uk-margin-remove-top">
              {{ local_page_keys.title_page_salary }}
            </div>
          </div>
          <div class="uk-width-expand">
            <div class="uk-grid uk-grid-small uk-margin" data-uk-grid>
              <!--выбор года-->
              <div class="uk-width-small">
                <div class="uk-position-relative">
                  <div class="uk-position-absolute tm-salary-select-tit">
                    {{ local_page_keys.year }}
                  </div>
                  <div>
                    <select v-model="selectedYear" class="uk-select uk-width-1-1" @change="changeYear">
                      <option value="2022">2022</option>
                      <option value="2023">2023</option>
                      <option value="2024">2024</option>
                      <option value="2025">2025</option>
                      <option value="2026">2026</option>
                    </select>
                  </div>
                </div>
              </div>
              <!--выбор недели-->
              <div class="uk-width-medium">
                <div class="uk-position-relative">
                  <div class="uk-position-absolute tm-salary-select-tit">
                    <div class="uk-grid tm-grid-xsmall uk-flex-middle" data-uk-grid>
                      <div>
                        {{ local_page_keys.week }}
                      </div>
                      <div>
                        <div class="uk-label tm-label" style="font-size: 11px;">
                          {{ rangeOfWeek }}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div>
                    <select class="uk-select uk-width-1-1" v-model="selectedWeek">
                      <option v-for="(week, index) in listOfWeeks" :value="week" :key="index + 'w' + week.week">
                        <template v-if="week.current">{{ week.week }} {{ local_page_keys.week }}</template>
                        <template v-else>{{ week.week }} {{ local_page_keys.week }}</template>
                      </option>
                    </select>
                  </div>
                </div>
              </div>
              <!--выбор роли-->
              <div style="width: 350px;">
                <div class="uk-position-relative">
                  <div class="uk-position-absolute tm-salary-select-tit">
                    {{ local_page_keys.lable_role_select }}
                  </div>
                  <div>
                    <v-select
                        :options="roles"
                        name="choosenRole"
                        ref="choosenRole"
                        id="choosenRole"
                        label="text"
                        :reduce="role => role.value"
                        @input="showUserSelect"
                        v-model="choosenRole"
                        class="tm-v-select">
                    </v-select>
                  </div>
                </div>
              </div>
              <!--выбор пользователя-->
              <div class="uk-width-expand">
                <div v-if="Object.keys(chosenUsers).length > 0" :mdClearable="true" class="uk-position-relative">
                  <div class="uk-position-absolute tm-salary-select-tit">
                    {{ local_page_keys.lable_users_select }}
                  </div>
                  <div>
                    <v-select
                        :options="chosenUsers"
                        ref="usersSelect" name="usersSelect" id="usersSelect"
                        label="email"
                        multiple
                        :reduce="user => user.id"
                        @input="showUserslist"
                        :closeOnSelect="false"
                        :clearable="true"
                        v-model="reportedUsers"
                        class="tm-v-select">
                      <template v-slot:option="option">
                        <template v-if="!reportedUsers.includes(option.id)">
                          <div v-if="!option.group">{{ option.name + "(" + option.email + ")" }}</div>
                          <div v-else>{{ option.email }}</div>
                        </template>
                        <template v-else>
                          <div class="vs__selected" v-if="!option.group">{{ option.name + "(" + option.email + ")" }}</div>
                          <div class="vs__selected" v-else>{{ option.email }}</div>
                        </template>
                      </template>
                    </v-select>
                  </div>
                </div>
              </div>
              <!--выбор статуса-->
              <div v-if="selectedStatus" class="uk-width-small">
                <div  class="uk-position-relative">
                  <div class="uk-position-absolute tm-salary-select-tit">
                    <div class="uk-grid tm-grid-xsmall uk-flex-middle" data-uk-grid>
                      <div>
                        {{local_page_keys.label_user_status}}
                      </div>
                    </div>
                  </div>
                  <div>
                    <select class="uk-select uk-width-1-1" v-model="selectedStatus">
                      <option v-for="status in listOfStatuses" :value="status.value" :key="status.value">
                        <template>{{ status.name }}</template>
                      </option>
                    </select>
                  </div>
                </div>
              </div>
              <!--кнопка-->
              <div v-if="reportedUsers.length > 0" class="uk-width-auto">
                <button class="uk-button uk-button-success" type="button" @click="getReport">
                  <!--{{ local_page_keys.lable_button_show_report }}-->
                  <md-icon style="font-size: 35px !important;">keyboard_arrow_right</md-icon>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="uk-card-body">
        <!--зп таблица ретушера-->
        <template v-if="choosenRole === 'retoucher'">
          <div v-if="sortedData && Object.keys(sortedData).length > 0" class="">
            <!--таблица-->
            <!--шапка-->
            <div class="uk-grid uk-grid-collapse uk-grid-divider uk-flex-middle uk-text-bold uk-text-meta uk-text-center uk-text-small"
                 data-uk-grid
                 data-uk-sticky="start: 200; animation: uk-animation-slide-top"
                 style="background-color: #fff;">
              <div style="width: 90px" v-if="showField(choosenRole, 'checked')">
                <div class="uk-padding-xsmall uk-text-uppercase uk-flex uk-flex-middle uk-flex-column uk-flex-center tm-salary-header-fix-min-height">
                  id
                </div>
              </div>
              <div class="uk-width-medium">
                <div class="uk-padding-xsmall uk-flex uk-flex-middle uk-flex-column uk-flex-center tm-salary-header-fix-min-height">
                  {{local_page_keys.header_admin_notes}}
                </div>
              </div>
              <div class="uk-width-expand">
                <div :class="'uk-grid uk-grid-collapse uk-grid-divider uk-flex-middle uk-child-width-1-'+(fields[choosenRole].length-1)+' tm-child-width-1-'+(fields[choosenRole].length-1)" data-uk-grid>
                  <div v-if="showField(choosenRole, 'user')" data-column="user">
                    <div class="uk-padding-xsmall uk-flex uk-flex-middle uk-flex-column uk-flex-center tm-salary-header-fix-min-height">
                      <div class="uk-margin-small-bottom">
                        {{ local_page_keys.user }}
                      </div>
                      <div class="tm-salary-sort"><AdminOrderHistoryTableHeader :sort_by="sortBy" value="email" @sortBy="onSortBy"></AdminOrderHistoryTableHeader></div>
                    </div>
                  </div>
                  <div v-if="showField(choosenRole, 'name')" data-column="name">
                    <div class="uk-padding-xsmall uk-flex uk-flex-middle uk-flex-column uk-flex-center tm-salary-header-fix-min-height">
                      <div class="uk-margin-small-bottom">
                        {{ local_page_keys.name }}
                      </div>
                      <div class="tm-salary-sort"><AdminOrderHistoryTableHeader :sort_by="sortBy" value="name" @sortBy="onSortBy"></AdminOrderHistoryTableHeader></div>
                    </div>
                  </div>
                  <div v-if="showField(choosenRole, 'number_of_orders')" data-column="number_of_orders">
                    <div class="uk-padding-xsmall uk-flex uk-flex-middle uk-flex-column uk-flex-center tm-salary-header-fix-min-height">
                      <div class="uk-margin-small-bottom">
                        {{ local_page_keys.number_of_orders }}
                      </div>
                      <div class="tm-salary-sort"><AdminOrderHistoryTableHeader :sort_by="sortBy" value="number_of_orders" @sortBy="onSortBy"></AdminOrderHistoryTableHeader></div>
                    </div>
                  </div>
                  <div v-if="showField(choosenRole, 'sum_for_orders')">
                    <div class="uk-padding-xsmall uk-flex uk-flex-middle uk-flex-column uk-flex-center tm-salary-header-fix-min-height">
                      <div class="uk-margin-small-bottom">
                        {{ local_page_keys.sum_for_orders }}
                      </div>
                      <div class="tm-salary-sort"><AdminOrderHistoryTableHeader :sort_by="sortBy" value="sum_for_orders" @sortBy="onSortBy"></AdminOrderHistoryTableHeader></div>
                    </div>
                  </div>
                  <div class="uk-grid-item-match" v-if="showField(choosenRole, 'number_of_waiting_minutes')">
                    <div class="uk-padding-xsmall uk-flex uk-flex-middle uk-flex-column uk-flex-center tm-salary-header-fix-min-height">
                      <div class="uk-margin-small-bottom">
                        {{ local_page_keys.number_of_waiting_minutes }}
                      </div>
                      <div class="tm-salary-sort"><AdminOrderHistoryTableHeader :sort_by="sortBy" value="number_of_waiting_minutes" @sortBy="onSortBy"></AdminOrderHistoryTableHeader></div>
                    </div>
                  </div>
                  <div v-if="showField(choosenRole, 'amount_for_waiting')">
                    <div class="uk-padding-xsmall uk-flex uk-flex-middle uk-flex-column uk-flex-center tm-salary-header-fix-min-height">
                      <div class="uk-margin-small-bottom">
                        {{ local_page_keys.amount_for_waiting }}
                      </div>
                      <div class="tm-salary-sort"><AdminOrderHistoryTableHeader :sort_by="sortBy" value="amount_for_waiting" @sortBy="onSortBy"></AdminOrderHistoryTableHeader></div>
                    </div>
                  </div>
                  <div v-if="showField(choosenRole, 'salary_bonus')">
                    <div class="uk-padding-xsmall uk-flex uk-flex-middle uk-flex-column uk-flex-center tm-salary-header-fix-min-height">
                      <div class="uk-margin-small-bottom">
                        {{ local_page_keys.salary_bonus }}
                      </div>
                      <div class="tm-salary-sort"><AdminOrderHistoryTableHeader :sort_by="sortBy" value="salary_bonus" @sortBy="onSortBy"></AdminOrderHistoryTableHeader></div>
                    </div>
                  </div>
                  <div v-if="showField(choosenRole, 'salary_bonus_amount')">
                    <div class="uk-padding-xsmall uk-flex uk-flex-middle uk-flex-column uk-flex-center tm-salary-header-fix-min-height">
                      <div class="uk-margin-small-bottom">
                        {{ local_page_keys.salary_bonus_amount }}
                      </div>
                      <div class="tm-salary-sort"><AdminOrderHistoryTableHeader :sort_by="sortBy" value="salary_bonus_amount" @sortBy="onSortBy"></AdminOrderHistoryTableHeader></div>
                    </div>
                  </div>
                  <div v-if="showField(choosenRole, 'bonus_for_schedule')">
                    <div class="uk-padding-xsmall uk-flex uk-flex-middle uk-flex-column uk-flex-center tm-salary-header-fix-min-height">
                      <div class="uk-margin-small-bottom">
                        {{ local_page_keys.bonus_for_schedule }}
                      </div>
                      <div class="tm-salary-sort"><AdminOrderHistoryTableHeader :sort_by="sortBy" value="bonus_for_schedule" @sortBy="onSortBy"></AdminOrderHistoryTableHeader></div>
                    </div>
                  </div>
                  <div v-if="showField(choosenRole, 'additional_payment')">
                    <div class="uk-padding-xsmall uk-flex uk-flex-middle uk-flex-column uk-flex-center tm-salary-header-fix-min-height">
                      <div class="uk-margin-small-bottom">
                        {{local_page_keys.header_admin_additional_payment}}
                      </div>
                      <div class="tm-salary-sort"><AdminOrderHistoryTableHeader :sort_by="sortBy" value="additional_payment" @sortBy="onSortBy"></AdminOrderHistoryTableHeader></div>
                    </div>
                  </div>
                  <div v-if="showField(choosenRole, 'whole_sum')">
                    <div class="uk-padding-xsmall uk-flex uk-flex-middle uk-flex-column uk-flex-center tm-salary-header-fix-min-height">
                      <div class="uk-margin-small-bottom">
                        {{ local_page_keys.whole_sum }}
                      </div>
                      <div class="tm-salary-sort"><AdminOrderHistoryTableHeader :sort_by="sortBy" value="whole_sum" @sortBy="onSortBy"></AdminOrderHistoryTableHeader></div>
                    </div>
                  </div>
                  <div v-if="showField(choosenRole, 'status')" data-column="status">
                    <div class="uk-padding-xsmall uk-flex uk-flex-middle uk-flex-column uk-flex-center tm-salary-header-fix-min-height">
                      <div class="uk-margin-small-bottom">
                        {{ local_page_keys.salary_head_paid }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!--суммы-->
            <div class="uk-grid uk-grid-collapse uk-grid-divider uk-flex-middle uk-text-bold uk-text-meta uk-text-center uk-text-small" data-uk-grid>
              <div style="width: 90px" v-if="showField(choosenRole, 'checked')">
                <div class="uk-padding-xxsmall" style="min-height: 30px"></div>
              </div>
              <div class="uk-width-medium">
                <div class="uk-padding-xxsmall" style="min-height: 30px"></div>
              </div>
              <div class="uk-width-expand">
                <div :class="'uk-grid uk-grid-collapse uk-grid-divider uk-flex-middle uk-child-width-1-'+(fields[choosenRole].length-1)+' tm-child-width-1-'+(fields[choosenRole].length-1)" data-uk-grid>
                  <div v-if="showField(choosenRole, 'user')" data-column="user">
                    <div class="uk-padding-xxsmall" style="min-height: 30px"></div>
                  </div>
                  <div v-if="showField(choosenRole, 'name')" data-column="name">
                    <div class="uk-padding-xxsmall" style="min-height: 30px"></div>
                  </div>
                  <div v-if="showField(choosenRole, 'number_of_orders')" data-column="number_of_orders">
                    <div class="uk-padding-xxsmall">
                      <div class="tm-salary-sum">Σ={{columnSum('number_of_orders')}}</div>
                    </div>
                  </div>
                  <div v-if="showField(choosenRole, 'sum_for_orders')">
                    <div class="uk-padding-xxsmall">
                      <div class="tm-salary-sum">Σ={{columnSum('sum_for_orders')}}</div>
                    </div>
                  </div>
                  <div class="uk-grid-item-match" v-if="showField(choosenRole, 'number_of_waiting_minutes')">
                    <div class="uk-padding-xxsmall">
                      <div class="tm-salary-sum">Σ={{columnSum('number_of_waiting_minutes')}}</div>
                    </div>
                  </div>
                  <div v-if="showField(choosenRole, 'amount_for_waiting')">
                    <div class="uk-padding-xxsmall">
                      <div class="tm-salary-sum">Σ={{columnSum('amount_for_waiting')}}</div>
                    </div>
                  </div>
                  <div v-if="showField(choosenRole, 'salary_bonus')">
                    <div class="uk-padding-xxsmall"></div>
                  </div>
                  <div v-if="showField(choosenRole, 'salary_bonus_amount')">
                    <div class="uk-padding-xxsmall">
                      <div class="tm-salary-sum">Σ={{columnSum('salary_bonus_amount')}}</div>
                    </div>
                  </div>
                  <div v-if="showField(choosenRole, 'bonus_for_schedule')">
                    <div class="uk-padding-xxsmall">
                      <div class="tm-salary-sum">Σ={{columnSum('bonus_for_schedule')}}</div>
                    </div>
                  </div>
                  <div v-if="showField(choosenRole, 'additional_payment')">
                    <div class="uk-padding-xxsmall">
                      <div class="tm-salary-sum">Σ={{columnSum('additional_payment')}}</div>
                    </div>
                  </div>
                  <div v-if="showField(choosenRole, 'whole_sum')">
                    <div class="uk-padding-xxsmall">
                      <div class="tm-salary-sum">Σ={{columnSum('whole_sum')}}</div>
                    </div>
                  </div>
                  <div v-if="showField(choosenRole, 'status')" data-column="status">
                    <div class="uk-padding-xxsmall" style="min-height: 30px"></div>
                  </div>
                </div>
              </div>
            </div>
            <hr class="uk-margin-small">
            <!--строки-->
            <div class="tm-salary-table uk-text-small">
              <template v-for="(row, key) in sortedData[choosenRole]">
                <div class="uk-grid uk-grid-collapse uk-flex-middle tm-grid-bg-hover" data-uk-grid :key="key">
                  <!--id-->
                  <div style="width: 90px" v-if="showField(choosenRole, 'checked')">
                    <div class="uk-padding-xsmall uk-text-center">
                      {{ "#" + row.user_id }}
                    </div>
                  </div>
                  <!--заметки-->
                  <div class="uk-width-medium">
                    <div class="uk-padding-xsmall">
                      <div v-if="row.note === null" class="uk-text-center">
                        <button type="button" @click="modalNoteDialog('create',row)" class="tm-button-add tm-button-success uk-button" data-uk-tooltip="title: Добавить заметку; offset: 5">
                          <md-icon class="uk-light">add</md-icon>
                        </button>
                      </div>
                      <div v-else >
                        {{row.note}}
                        <button type="button" @click="modalNoteDialog('edit',row)" class="tm-button-edit" data-uk-tooltip="title: Редактирование заметки; offset: 5">
                          <md-icon class="">settings</md-icon>
                        </button>
                      </div>
                    </div>
                  </div>
                  <div class="uk-width-expand">
                    <div :class="'uk-grid uk-grid-collapse uk-flex-middle uk-child-width-1-'+(fields[choosenRole].length-1)+' tm-child-width-1-'+(fields[choosenRole].length-1)" data-uk-grid>
<!--                      data-uk-height-match="target: > div > div"-->
                      <!--юзер-->
                      <div v-if="showField(choosenRole, 'user')">
                        <div class="uk-padding-xsmall uk-text-truncate tm-cell-user" :data-uk-tooltip="row.email">
                          <span class="tm-label uk-label uk-margin-xsmall-right"> {{ getNumberFromEmail(row.email) }}</span> {{ row.email }}
                        </div>
                      </div>
                      <!--имя-->
                      <div class="uk-text-center" v-if="showField(choosenRole, 'name')">
                        <div class="uk-padding-xsmall tm-cell-name uk-text-truncate" :data-uk-tooltip="row.name">
                          {{ row.name }}
                        </div>
                      </div>
                      <!--Кол-во заказов-->
                      <div v-if="showField(choosenRole, 'number_of_orders')">
                        <div class="uk-padding-xsmall uk-text-center tm-number-of-orders">
                          {{ row.number_of_orders }}
                        </div>
                      </div>
                      <!--Сумма за заказы (грн)-->
                      <div v-if="showField(choosenRole, 'sum_for_orders')">
                        <div class="uk-padding-xsmall uk-text-center tm-sum-for-orders">
                          {{ row.sum_for_orders }}
                        </div>
                      </div>
                      <!--Кол-во минут простоя (мин)-->
                      <div v-if="showField(choosenRole, 'number_of_waiting_minutes')">
                        <div class="uk-padding-xsmall uk-text-center tm-number-of-waiting-minutes">
                          {{ row.number_of_waiting_minutes }}
                        </div>
                      </div>
                      <!--Компенсация простоя (грн)-->
                      <div v-if="showField(choosenRole, 'amount_for_waiting')">
                        <div class="uk-padding-xsmall uk-text-center tm-amount-for-waiting">
                          {{ row.amount_for_waiting }}
                        </div>
                      </div>
                      <!--Премия (%)-->
                      <div v-if="showField(choosenRole, 'salary_bonus')">
                        <div class="uk-padding-xsmall uk-text-center tm-salary-bonus">
                          {{ row.salary_bonus }}
                        </div>
                      </div>
                      <!--Премия (грн)-->
                      <div v-if="showField(choosenRole, 'salary_bonus_amount')">
                        <div class="uk-padding-xsmall uk-text-center tm-salary-bonus-amount">
                          {{ row.salary_bonus_amount }}
                        </div>
                      </div>
                      <!--Бонус за график (грн)-->
                      <div v-if="showField(choosenRole, 'bonus_for_schedule')">
                        <div class="uk-padding-xsmall uk-text-center tm-bonus-for-schedule">
                          {{ row.bonus_for_schedule }}
                        </div>
                      </div>
                      <!--Доп выплата (грн)-->
                      <div v-if="showField(choosenRole, 'additional_payment')">
                        <div class="uk-padding-xsmall uk-text-center tm-additional-payment">
                          <template v-if="!row.paid_on">
                            <button type="button" v-if="row.additional_payment === 0" @click="modalSumDialog('create',row)" class="tm-button-add tm-button-success uk-button" data-uk-tooltip="title: Добавить сумму. Доступно для редактирования до момента оплаты (колонка ОПЛАЧЕНО); offset: 5">
                              <md-icon class="uk-light">add</md-icon>
                            </button>
                            <div v-else class="uk-grid tm-grid-xsmall uk-flex-middle uk-flex-center" data-uk-grid>
                              <div v-if="row.additional_payment_purpose" :data-uk-tooltip="'title:' + row.additional_payment_purpose +'; offset: 5'">
                                {{row.additional_payment}}
                              </div>
                              <div v-else>
                                {{row.additional_payment}}
                              </div>
                              <div>
                                <button type="button" @click="modalSumDialog('edit',row)" class="tm-button-edit" data-uk-tooltip="title: Редактирование сумму. Доступно для редактирования до момента оплаты (колонка ОПЛАЧЕНО); offset: 5">
                                  <md-icon class="">settings</md-icon>
                                </button>
                              </div>
                            </div>
                          </template>
                          <template v-else>
                            <div :data-uk-tooltip="'title:' + row.additional_payment_purpose +'; offset: 5'">
                              {{row.additional_payment}}
                            </div>
                          </template>
                        </div>
                      </div>
                      <!--Общая сумму к начислению (грн)-->
                      <div v-if="showField(choosenRole, 'whole_sum')">
                        <div class="uk-padding-xsmall uk-text-center tm-whole-sum">
                          {{ row.whole_sum }}
                        </div>
                      </div>
                      <!--Оплачено-->
                      <div v-if="showField(choosenRole, 'status')">
                        <div class="uk-padding-xsmall uk-text-center tm-cell-status">
                          <template v-if="row.status">
                            <md-icon style="color: #4caf50;">done</md-icon>
                            <div v-if="row.paid_on" class="uk-label tm-label" style="font-size: 11px;">
                              {{ row.paid_on }}
                            </div>
                          </template>
                          <template v-else>

                          </template>
                          <!--{{ row.status ? local_page_keys.paid : local_page_keys.not_paid }}-->
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </template>
            </div>
            <hr class="uk-margin"/>
            <!--экспорт + оплата-->
            <div class="uk-grid uk-grid-small" data-uk-grid v-show="true">
              <!--кнопка оплата-->
              <div v-if="showPayedButton">
                <button type="button" :disabled="disabledButtonForPayed" class="uk-button uk-button-success" @click="writePayedRetouchers">
                  {{ local_page_keys.button_mark_as_payed }}
                  <span class="uk-icon uk-spinner uk-margin-left uk-light" data-uk-spinner="ratio: 0.7" v-if="loadingPayment"></span>
                </button>
              </div>
              <!--кнопка экспорт-->
              <div>
                <button type="button" class="uk-button uk-button-success" @click="getExcelReport">
                  {{ local_page_keys.salary_button_exp_all }}
                  <span class="uk-icon uk-spinner uk-margin-left uk-light" data-uk-spinner="ratio: 0.7" v-if="loadingExport"></span>
                </button>
              </div>
            </div>
          </div>
          <!--прилодер-->
          <div v-if="loading">
            <v-progress-circular
                :width="2"
                indeterminate
                style="color: forestgreen"></v-progress-circular>
          </div>
        </template>

        <!--зп таблица проретушера-->
        <template v-if="choosenRole === 'pro-retoucher'">
          <div v-if="sortedData && Object.keys(sortedData).length > 0" class="">
            <!--таблица-->
            <!--шапка-->
            <div class="uk-grid uk-grid-collapse uk-grid-divider uk-flex-middle uk-text-bold uk-text-meta uk-text-center uk-text-small"
                 data-uk-grid
                 data-uk-sticky="start: 200; animation: uk-animation-slide-top"
                 style="background-color: #fff;">
              <div style="width: 90px" v-if="showField(choosenRole, 'checked')">
                <div class="uk-padding-xsmall uk-text-uppercase uk-flex uk-flex-middle uk-flex-column uk-flex-center tm-salary-header-fix-min-height">
                  id
                </div>
              </div>
              <div class="uk-width-medium">
                <div class="uk-padding-xsmall uk-flex uk-flex-middle uk-flex-column uk-flex-center tm-salary-header-fix-min-height">
                  {{local_page_keys.header_admin_notes}}
                </div>
              </div>
              <div class="uk-width-expand">
                <div :class="'uk-grid uk-grid-collapse uk-grid-divider uk-flex-middle uk-child-width-1-'+(fields[choosenRole].length-1)+' tm-child-width-1-'+(fields[choosenRole].length-1)" data-uk-grid>
                  <div v-if="showField(choosenRole, 'user')" data-column="user">
                    <div class="uk-padding-xsmall uk-flex uk-flex-middle uk-flex-column uk-flex-center tm-salary-header-fix-min-height">
                      <div class="uk-margin-small-bottom">
                        {{ local_page_keys.user }}
                      </div>
                      <div class="tm-salary-sort"><AdminOrderHistoryTableHeader :sort_by="sortBy" value="email" @sortBy="onSortBy"></AdminOrderHistoryTableHeader></div>
                    </div>
                  </div>
                  <div v-if="showField(choosenRole, 'name')" data-column="name">
                    <div class="uk-padding-xsmall uk-flex uk-flex-middle uk-flex-column uk-flex-center tm-salary-header-fix-min-height">
                      <div class="uk-margin-small-bottom">
                        {{ local_page_keys.name }}
                      </div>
                      <div class="tm-salary-sort"><AdminOrderHistoryTableHeader :sort_by="sortBy" value="name" @sortBy="onSortBy"></AdminOrderHistoryTableHeader></div>
                    </div>
                  </div>
                  <div v-if="showField(choosenRole, 'num_orders')">
                    <div class="uk-padding-xsmall uk-flex uk-flex-middle uk-flex-column uk-flex-center tm-salary-header-fix-min-height">
                      <div class="uk-margin-small-bottom">
                        {{ local_page_keys.num_orders }}
                      </div>
                      <div class="tm-salary-sort"><AdminOrderHistoryTableHeader :sort_by="sortBy" value="num_orders" @sortBy="onSortBy"></AdminOrderHistoryTableHeader></div>
                    </div>
                    <div
                        class="uk-dropdown tm-dropdown tm-dropdown-bottom-center"
                        data-uk-dropdown="animation: uk-animation-slide-top-small; pos: bottom-center; delay-hide: 400; delay-show: 0; offset: 10">
                      <div class="uk-text-light" v-html="local_page_keys.tooltip_all_pro_hours_good_sum"></div>
                    </div>
                  </div>
                  <div class="uk-grid-item-match" v-if="showField(choosenRole, 'all_pro_hours_good_sum')">
                    <div class="uk-padding-xsmall uk-flex uk-flex-middle uk-flex-column uk-flex-center tm-salary-header-fix-min-height">
                      <div class="uk-margin-small-bottom">
                        {{ local_page_keys.all_pro_hours_good_sum }}
                      </div>
                      <div class="tm-salary-sort"><AdminOrderHistoryTableHeader :sort_by="sortBy" value="all_pro_hours_good_sum" @sortBy="onSortBy"></AdminOrderHistoryTableHeader></div>
                    </div>
                    <div
                        class="uk-dropdown tm-dropdown tm-dropdown-bottom-center"
                        data-uk-dropdown="animation: uk-animation-slide-top-small; pos: bottom-center; delay-hide: 400; delay-show: 0; offset: 10">
                      <div class="uk-text-light" v-html="local_page_keys.tooltip_all_pro_hours_good_sum"></div>
                    </div>
                  </div>
                  <div v-if="showField(choosenRole, 'shift_salary')">
                    <div class="uk-padding-xsmall uk-flex uk-flex-middle uk-flex-column uk-flex-center tm-salary-header-fix-min-height">
                      <div class="uk-margin-small-bottom">
                        {{ local_page_keys.shift_salary }}
                      </div>
                      <div class="tm-salary-sort"><AdminOrderHistoryTableHeader :sort_by="sortBy" value="shift_salary" @sortBy="onSortBy"></AdminOrderHistoryTableHeader></div>
                    </div>
                  </div>
                  <div v-if="showField(choosenRole, 'all_bonus_for_pro')">
                    <div class="uk-padding-xsmall uk-flex uk-flex-middle uk-flex-column uk-flex-center tm-salary-header-fix-min-height">
                      <div class="uk-margin-small-bottom">
                        {{ local_page_keys.all_bonus_for_pro }}
                      </div>
                      <div class="tm-salary-sort"><AdminOrderHistoryTableHeader :sort_by="sortBy" value="all_bonus_for_pro" @sortBy="onSortBy"></AdminOrderHistoryTableHeader></div>
                    </div>
                    <div
                        class="uk-dropdown tm-dropdown tm-dropdown-bottom-center"
                        data-uk-dropdown="animation: uk-animation-slide-top-small; pos: bottom-center; delay-hide: 400; delay-show: 0; offset: 10">
                      <div class="uk-text-light" v-html="local_page_keys.tooltip_all_bonus_for_pro"></div>
                    </div>
                  </div>
                  <div v-if="showField(choosenRole, 'all_bonus_money')">
                    <div class="uk-padding-xsmall uk-flex uk-flex-middle uk-flex-column uk-flex-center tm-salary-header-fix-min-height">
                      <div class="uk-margin-small-bottom">
                        {{ local_page_keys.all_bonus_money }}
                      </div>
                      <div class="tm-salary-sort"><AdminOrderHistoryTableHeader :sort_by="sortBy" value="all_bonus_money" @sortBy="onSortBy"></AdminOrderHistoryTableHeader></div>
                    </div>
                    <div
                        class="uk-dropdown tm-dropdown tm-dropdown-bottom-center"
                        data-uk-dropdown="animation: uk-animation-slide-top-small; pos: bottom-center; delay-hide: 400; delay-show: 0; offset: 10">
                      <div class="uk-text-light" v-html="local_page_keys.tooltip_all_bonus_money"></div>
                    </div>
                  </div>
                  <div v-if="showField(choosenRole, 'month_bonus')">
                    <div class="uk-padding-xsmall uk-flex uk-flex-middle uk-flex-column uk-flex-center tm-salary-header-fix-min-height">
                      <div class="uk-margin-small-bottom">
                        {{ local_page_keys.month_bonus }}
                      </div>
                      <div class="tm-salary-sort"><AdminOrderHistoryTableHeader :sort_by="sortBy" value="month_bonus" @sortBy="onSortBy"></AdminOrderHistoryTableHeader></div>
                    </div>
                    <div
                        class="uk-dropdown tm-dropdown tm-dropdown-bottom-center"
                        data-uk-dropdown="animation: uk-animation-slide-top-small; pos: bottom-center; delay-hide: 400; delay-show: 0; offset: 10">
                      <div class="uk-text-light" v-html="local_page_keys.tooltip_admin_month_bonus"></div>
                    </div>
                  </div>
                  <div v-if="showField(choosenRole, 'place_bonus')">
                    <div class="uk-padding-xsmall uk-flex uk-flex-middle uk-flex-column uk-flex-center tm-salary-header-fix-min-height">
                      <div class="uk-margin-small-bottom">
                        {{ local_page_keys.place_bonus }}
                      </div>
                      <div class="tm-salary-sort"><AdminOrderHistoryTableHeader :sort_by="sortBy" value="place_bonus" @sortBy="onSortBy"></AdminOrderHistoryTableHeader></div>
                    </div>
                  </div>
                  <div v-if="showField(choosenRole, 'additional_payment')">
                    <div class="uk-padding-xsmall uk-flex uk-flex-middle uk-flex-column uk-flex-center tm-salary-header-fix-min-height">
                      <div class="uk-margin-small-bottom">
                        {{local_page_keys.header_admin_additional_payment}}
                      </div>
                      <div class="tm-salary-sort"><AdminOrderHistoryTableHeader :sort_by="sortBy" value="additional_payment" @sortBy="onSortBy"></AdminOrderHistoryTableHeader></div>
                    </div>
                  </div>
                  <div v-if="showField(choosenRole, 'whole_sum')">
                    <div class="uk-padding-xsmall uk-flex uk-flex-middle uk-flex-column uk-flex-center tm-salary-header-fix-min-height">
                      <div class="uk-margin-small-bottom">
                        {{ local_page_keys.whole_sum }}
                      </div>
                      <div class="tm-salary-sort"><AdminOrderHistoryTableHeader :sort_by="sortBy" value="whole_sum" @sortBy="onSortBy"></AdminOrderHistoryTableHeader></div>
                    </div>
                  </div>
                  <div v-if="showField(choosenRole, 'status')" data-column="status">
                    <div class="uk-padding-xsmall uk-flex uk-flex-middle uk-flex-column uk-flex-center tm-salary-header-fix-min-height">
                      <div class="uk-margin-small-bottom">
                        {{ local_page_keys.salary_head_paid }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!--суммы-->
            <div class="uk-grid uk-grid-collapse uk-grid-divider uk-flex-middle uk-text-bold uk-text-meta uk-text-center uk-text-small" data-uk-grid>
              <div style="width: 90px" v-if="showField(choosenRole, 'checked')">
                <div class="uk-padding-xxsmall" style="min-height: 30px"></div>
              </div>
              <div class="uk-width-medium">
                <div class="uk-padding-xxsmall" style="min-height: 30px"></div>
              </div>
              <div class="uk-width-expand">
                <div :class="'uk-grid uk-grid-collapse uk-grid-divider uk-flex-middle uk-child-width-1-'+(fields[choosenRole].length-1)+' tm-child-width-1-'+(fields[choosenRole].length-1)" data-uk-grid>
                  <div v-if="showField(choosenRole, 'user')" data-column="user">
                    <div class="uk-padding-xxsmall" style="min-height: 30px"></div>
                  </div>
                  <div v-if="showField(choosenRole, 'name')" data-column="name">
                    <div class="uk-padding-xxsmall" style="min-height: 30px"></div>
                  </div>
                  <div v-if="showField(choosenRole, 'num_orders')" data-column="num_orders">
                    <div class="uk-padding-xxsmall">
                      <div class="tm-salary-sum">Σ={{columnSum('num_orders')}}</div>
                    </div>
                  </div>
                  <div v-if="showField(choosenRole, 'all_pro_hours_good_sum')">
                    <div class="uk-padding-xxsmall">
                      <div class="tm-salary-sum">Σ={{columnSum('all_pro_hours_good_sum')}}</div>
                    </div>
                  </div>
                  <div class="uk-grid-item-match" v-if="showField(choosenRole, 'shift_salary')">
                    <div class="uk-padding-xxsmall">
                      <div class="tm-salary-sum">Σ={{columnSum('shift_salary')}}</div>
                    </div>
                  </div>
                  <div v-if="showField(choosenRole, 'all_bonus_for_pro')">
                    <div class="uk-padding-xxsmall">
                      <div class="tm-salary-sum">Σ={{columnSum('all_bonus_for_pro')}}</div>
                    </div>
                  </div>
                  <div v-if="showField(choosenRole, 'all_bonus_money')">
                    <div class="uk-padding-xxsmall">
                      <div class="tm-salary-sum">Σ={{columnSum('all_bonus_money')}}</div>
                    </div>
                  </div>
                  <div v-if="showField(choosenRole, 'month_bonus')">
                    <div class="uk-padding-xxsmall">
                      <div class="tm-salary-sum">Σ={{columnSum('month_bonus')}}</div>
                    </div>
                  </div>
                  <div v-if="showField(choosenRole, 'place_bonus')">
                    <div class="uk-padding-xxsmall">
                      <div class="tm-salary-sum">Σ={{columnSum('place_bonus')}}</div>
                    </div>
                  </div>
                  <div v-if="showField(choosenRole, 'additional_payment')">
                    <div class="uk-padding-xxsmall">
                      <div class="tm-salary-sum">Σ={{columnSum('additional_payment')}}</div>
                    </div>
                  </div>
                  <div v-if="showField(choosenRole, 'whole_sum')">
                    <div class="uk-padding-xxsmall">
                      <div class="tm-salary-sum">Σ={{columnSum('whole_sum')}}</div>
                    </div>
                  </div>
                  <div v-if="showField(choosenRole, 'status')" data-column="status">
                    <div class="uk-padding-xxsmall" style="min-height: 30px"></div>
                  </div>
                </div>
              </div>
            </div>
            <hr class="uk-margin-small">
            <!--строки-->
            <div class="tm-salary-table uk-text-small">
              <template v-for="(row, key) in sortedData[choosenRole]">
                <div class="uk-grid uk-grid-collapse uk-flex-middle tm-grid-bg-hover" data-uk-grid :key="key">
                  <!--id-->
                  <div style="width: 90px" v-if="showField(choosenRole, 'checked')">
                    <div class="uk-padding-xsmall uk-text-center">
                      {{ "#" + row.user_id }}
                    </div>
                  </div>
                  <!--заметки-->
                  <div class="uk-width-medium">
                    <div class="uk-padding-xsmall">
                      <div v-if="row.note === null" class="uk-text-center">
                        <button type="button" @click="modalNoteDialog('create',row)" class="tm-button-add tm-button-success uk-button" data-uk-tooltip="title: Добавить заметку; offset: 5">
                          <md-icon class="uk-light">add</md-icon>
                        </button>
                      </div>
                      <div v-else >
                        {{row.note}}
                        <button type="button" @click="modalNoteDialog('edit',row)" class="tm-button-edit" data-uk-tooltip="title: Редактирование заметки; offset: 5">
                          <md-icon class="">settings</md-icon>
                        </button>
                      </div>
                    </div>
                  </div>
                  <div class="uk-width-expand">
                    <div :class="'uk-grid uk-grid-collapse uk-flex-middle uk-child-width-1-'+(fields[choosenRole].length-1)+' tm-child-width-1-'+(fields[choosenRole].length-1)" data-uk-grid>
<!--                      data-uk-height-match="target: > div > div"-->
                      <!--юзер-->
                      <div v-if="showField(choosenRole, 'user')">
                        <div class="uk-padding-xsmall uk-text-truncate tm-cell-user"
                             :data-uk-tooltip="row.email">
                          <span class="tm-label uk-label uk-margin-xsmall-right"> {{ getNumberFromEmail(row.email) }}</span> {{ row.email }}
                        </div>
                      </div>
                      <!--имя-->
                      <div class="uk-text-center" v-if="showField(choosenRole, 'name')">
                        <div class="uk-padding-xsmall tm-cell-name uk-text-truncate" :data-uk-tooltip="row.name">
                          {{ row.name }}
                        </div>
                      </div>
                      <!--Кол-во заказов-->
                      <div v-if="showField(choosenRole, 'num_orders')">
                        <div class="uk-padding-xsmall uk-text-center tm-number-of-orders_">
                          {{ row.num_orders }}
                        </div>
                      </div>
                      <!--Количество успешно отработанных часов за неделю-->
                      <div v-if="showField(choosenRole, 'all_pro_hours_good_sum')">
                        <div class="uk-padding-xsmall uk-text-center tm-sum-for-orders">
                          {{ row.all_pro_hours_good_sum }}
                        </div>
                      </div>
                      <!--Сумма за отработанные часы-->
                      <div v-if="showField(choosenRole, 'shift_salary')">
                        <div class="uk-padding-xsmall uk-text-center tm-number-of-waiting-minutes">
                          {{ row.shift_salary }}
                        </div>
                        <div v-if="row.num_orders > 0 && getTooltipData(row,'shift_salary')"
                             :id="'tooltipData' + key"
                             style="width:400px"
                             class="uk-dropdown tm-dropdown tm-dropdown-bottom-center"
                             data-uk-dropdown="animation: uk-animation-slide-top-small; pos: bottom-center; delay-hide: 400; delay-show: 0; offset: 10">
                          <div class="uk-text-left" v-html="getTooltipData(row,'shift_salary')"></div>
                        </div>
                      </div>
                      <!--Бонус за качество (%)-->
                      <div v-if="showField(choosenRole, 'all_bonus_for_pro')">
                        <div class="uk-padding-xsmall uk-text-center tm-amount-for-waiting">
                          {{ row.all_bonus_for_pro }}
                        </div>
                      </div>
                      <!--Бонус за качество (грн)-->
                      <div v-if="showField(choosenRole, 'all_bonus_money')">
                        <div class="uk-padding-xsmall uk-text-center tm-salary-bonus">
                          {{ row.all_bonus_money }}
                        </div>
                      </div>
                      <!--Ежемесячная премия за проверенные заказы (грн)-->
                      <div v-if="showField(choosenRole, 'month_bonus')">
                        <div class="uk-padding-xsmall uk-text-center tm-salary-bonus-amount">
                          {{ row.month_bonus }}
                        </div>
                      </div>
                      <!--Премия за место в рейтинге (грн)-->
                      <div v-if="showField(choosenRole, 'place_bonus')">
                        <div class="uk-padding-xsmall uk-text-center tm-bonus-for-schedule">
                          {{ row.place_bonus }}
                        </div>
                      </div>
                      <!--Доп выплата (грн)-->
                      <div v-if="showField(choosenRole, 'additional_payment')">
                        <div class="uk-padding-xsmall uk-text-center tm-additional-payment">
                          <template v-if="!row.paid_on">
                            <button type="button" v-if="row.additional_payment === 0" @click="modalSumDialog('create',row)" class="tm-button-add tm-button-success uk-button" data-uk-tooltip="title: Добавить сумму. Доступно для редактирования до момента оплаты (колонка ОПЛАЧЕНО); offset: 5">
                              <md-icon class="uk-light">add</md-icon>
                            </button>
                            <div v-else class="uk-grid tm-grid-xsmall uk-flex-middle uk-flex-center" data-uk-grid>
                              <div v-if="row.additional_payment_purpose" :data-uk-tooltip="'title:' + row.additional_payment_purpose +'; offset: 5'">
                                {{row.additional_payment}}
                              </div>
                              <div v-else>
                                {{row.additional_payment}}
                              </div>
                              <div>
                                <button type="button" @click="modalSumDialog('edit',row)" class="tm-button-edit" data-uk-tooltip="title: Редактирование сумму. Доступно для редактирования до момента оплаты (колонка ОПЛАЧЕНО); offset: 5">
                                  <md-icon class="">settings</md-icon>
                                </button>
                              </div>
                            </div>
                          </template>
                          <template v-else>
                            <div :data-uk-tooltip="'title:' + row.additional_payment_purpose +'; offset: 5'">
                              {{row.additional_payment}}
                            </div>
                          </template>
                        </div>
                      </div>
                      <!--Общая сумму к начислению (грн)-->
                      <div v-if="showField(choosenRole, 'whole_sum')">
                        <div class="uk-padding-xsmall uk-text-center tm-whole-sum">
                          {{ row.whole_sum }}
                        </div>
                      </div>
                      <!--Оплачено-->
                      <div v-if="showField(choosenRole, 'status')">
                        <div class="uk-padding-xsmall uk-text-center tm-cell-status">
                          <template v-if="row.status">
                            <md-icon style="color: #4caf50;">done</md-icon>
                            <div v-if="row.paid_on" class="uk-label tm-label" style="font-size: 11px;">
                              {{ row.paid_on }}
                            </div>
                          </template>
                          <template v-else>

                          </template>
                          <!--{{ row.status ? local_page_keys.paid : local_page_keys.not_paid }}-->
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </template>
            </div>
            <!--экспорт + оплата-->
            <hr class="uk-margin"/>
            <div class="uk-grid uk-grid-small" data-uk-grid v-show="true">
              <!--кнопка оплата-->
              <div v-if="showPayedButton">
                <button type="button" :disabled="disabledButtonForPayed" class="uk-button uk-button-success" @click="writePayedRetouchers">
                  {{ local_page_keys.button_mark_as_payed }}
                  <span class="uk-icon uk-spinner uk-margin-left uk-light" data-uk-spinner="ratio: 0.7" v-if="loadingPayment"></span>
                </button>
              </div>
              <!--кнопка экспорт-->
              <div>
                <button type="button" class="uk-button uk-button-success" @click="getExcelReport">
                  {{ local_page_keys.salary_button_exp_all }}
                  <span class="uk-icon uk-spinner uk-margin-left uk-light" data-uk-spinner="ratio: 0.7" v-if="loadingExport"></span>
                </button>
              </div>
            </div>
          </div>
          <!--прилодер-->
          <div v-if="loading">
            <v-progress-circular
                :width="2"
                indeterminate
                style="color: forestgreen"></v-progress-circular>
          </div>
        </template>
      </div>
    </div>

    <!--модалка редактирования суммы доп оплаты-->
    <template v-if="showModalSumDialog">
      <div style="display: block" class="uk-modal uk-open uk-animation-fade uk-animation-fast uk-flex-top" @blur="closeModalSumDialog">
        <div class="uk-modal-dialog uk-margin-auto-vertical tm-func-modal" v-click-outside="closeModalSumDialog">
          <div class="uk-modal-header">
            <div class="tm-background-green uk-padding-xsmall uk-position-top-right uk-text-bold tm-light 8"
                 style="cursor: pointer;"
                 @click="closeModalSumDialog">
              <md-icon>close</md-icon>
            </div>
            <div class="uk-modal-title">
              <div class="uk-grid uk-flex-middle uk-grid-small" data-uk-grid>
                <div class="uk-text-bold">
                  Доп. оплата для {{additionalPayment['email']}}
                </div>
              </div>
            </div>
          </div>
          <div class="uk-modal-body">
            <div data-uk-grid class="uk-grid uk-flex-middle uk-grid-small uk-child-width-1-1">
              <div>
                <div class="uk-margin-xsmall uk-text-small">
                  Сумма
                </div>
                <div>
                  <input v-model="additionalPayment['sum']" :class="{ 'uk-form-danger': isErrorSum }" class="uk-input" placeholder="например, 123"/>
                </div>
                <div v-if="isErrorSum" class="uk-text-danger">
                  {{ errorMessageSum }}
                </div>
                <div class="uk-margin-xsmall uk-text-small uk-text-muted">
                  <div class="uk-grid tm-grid-xsmall uk-flex-middle" data-uk-grid>
                    <div class="uk-width-auto">
                      <md-icon class="uk-text-muted">info_outline</md-icon>
                    </div>
                    <div class="uk-width-expand" style="line-height: 1.2">
                      Для внесения допускаются целые положительные значения.
                    </div>
                  </div>
                </div>
              </div>
              <div>
                <div class="uk-margin-xsmall uk-text-small">
                  Назначение
                </div>
                <input v-model="additionalPayment['purpose']" class="uk-input"/>
              </div>
            </div>
            <div class="uk-margin-medium-top">
              <button type="button" class="uk-button uk-button-default uk-modal-close" @click="closeModalSumDialog">Отмена</button>
              <button type="button" class="uk-button tm-button-success uk-margin-xsmall-left" @click="saveAdditionalPayment()">{{modeModalSumDialog}}</button>
            </div>
          </div>
        </div>
      </div>
    </template>

    <!--модалка для заметок-->
    <template v-if="showModalNoteDialog">
      <div style="display: block" class="uk-modal uk-open uk-animation-fade uk-animation-fast uk-flex-top" @blur="closeModalNoteDialog">
        <div class="uk-modal-dialog uk-margin-auto-vertical tm-func-modal" v-click-outside="closeModalNoteDialog">
          <div class="uk-modal-header">
            <div class="tm-background-green uk-padding-xsmall uk-position-top-right uk-text-bold tm-ligh 9"
                 style="cursor: pointer;"
                 @click="closeModalNoteDialog">
              <md-icon>close</md-icon>
            </div>
            <div class="uk-modal-title">
              <div class="uk-grid uk-flex-middle uk-grid-small" data-uk-grid>
                <div class="uk-text-bold">
                  Заметка для {{ note['email'] }}
                </div>
              </div>
            </div>
          </div>
          <div class="uk-modal-body">
            <div data-uk-grid class="uk-grid uk-flex-middle uk-grid-small uk-child-width-1-1">
              <div>
                <div class="uk-margin-xsmall uk-text-small">
                  Заметка
                </div>
                <div>
                  <textarea v-model="note['text']" :class="{ 'uk-form-danger': isErrorNote }" class="uk-textarea" rows="5"></textarea>
                </div>
                <div v-if="isErrorNote" class="uk-text-danger">
                  {{ errorMessageNote }}
                </div>
              </div>
              <div class="uk-margin-medium-top">
                <button type="button" class="uk-button uk-button-default uk-modal-close" @click="closeModalNoteDialog">Отмена</button>
                <button type="button" class="uk-button tm-button-success uk-margin-xsmall-left" @click="saveNote()">{{modeModalSumDialog}}</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import AdminOrderHistoryTableHeader from "@/pages/Dashboard/Components/AdminOrderHistoryTableHeader";
import axios from "axios";
import localStorageMixin from '@/mixins/saveFilterParamsLocalStorageMixin';
import {round} from "lodash/math";

const url = process.env.VUE_APP_API_BASE_URL;

export default {
  name: 'Salary2',
  components: {
    AdminOrderHistoryTableHeader,
  },
  mixins: [localStorageMixin],
  data() {
    return {
      headers: [
        {
          text: 'User name',
          value: 'user_name',
        },
        {
          text: 'Role',
          value: 'user_role',
        },
        {
          text: 'Number of orders',
          value: 'orders_count',
        },
        {
          text: 'Order`s price',
          value: 'total_orders_price',
        },
        {
          text: 'Client`s tips',
          value: 'clients_tips',
        },
        {
          text: 'Summ',
          value: 'all_amount',
        },
      ],
      headers_empty: [
        {
          text: '',
          align: 'start',
          value: 'user_name'
        },
        {
          text: '',
          align: 'center',
          value: 'empty_base'
        }
      ],
      fields: {
        'retoucher': [
          'checked',
          'user',
          'name',
          'sum_for_orders',
          'amount_for_waiting',
          'bonus_for_schedule',
          'number_of_orders',
          'number_of_waiting_minutes',
          'salary_bonus',
          'salary_bonus_amount',
          'additional_payment',
          'status',
          'whole_sum'
        ],
        'junior-retoucher': [
          'checked',
          'user',
          'name',
          'sum_for_orders',
          'amount_for_waiting',
          'bonus_for_schedule',
          'number_of_orders',
          'number_of_waiting_minutes',
          'salary_bonus',
          'additional_payment',
          'status',
          'whole_sum'
        ],
        'pro-retoucher': [
          'checked',
          'user',
          'name',
          'num_orders',
          'all_pro_hours_good_sum',
          'shift_salary',
          'month_bonus',
          'all_bonus_for_pro',
          'all_bonus_money',
          'place_bonus',
          'additional_payment',
          'status',
          'whole_sum'

        ],
        'senior-retoucher': [
          'checked',
          'user',
          'name',
          'number_of_orders'
        ],
      },
      showDateRangePiecker: false,
      dialogVisible: false,
      loading: false,
      loadingWeek: false,
      loadingExport: false,
      loadingPayment:false,
      showWeek: true,
      empty_base: false,
      search: '',
      local_page_keys: {},
      todayDate: '',
      choosenPeriod: [],
      choosenRole: [],
      roles: [
        {
          text: "retouchers",
          value: "retoucher"
        },
        {
          text: "pro-retouchers",
          value: "pro-retoucher"
        },
        {
          text: "junior-retouchers",
          value: "junior-retoucher"
        },
        {
          text: "senior-retouchers",
          value: "senior-retoucher"
        },
      ],
      listByRoles: {},
      chosenUsers: {},
      reportedUsers: [],
      tab: null,
      tabPayed: null,
      sortedData: [],
      sortedPayed: [],
      startTime: '00:00',
      endTime: '24:00',
      select_to_pay: [],
      requestedUsers: [],
      weeks: {},
      weeksRight: {},
      weeksLeft: {},
      usedWeek: {},
      usedWeekNumber: 1,
      roleForWeek: null,
      listForWeek: [],
      listForWeekCheckAll: true,
      getterKey: 0,
      date: new Date(),
      selectedWeek: 1,
      currentWeek: 1,
      selectedYear: null,
      activeTab: 'retoucher',
      selectedFilter: {
        week: -1,
        year: -1,
      },
      listOfWeeks: [],
      rangeOfWeek: "",
      sortBy: {
        column: 'created_at',
        order: 'desc'
      },
      showModalSumDialog: false,
      additionalPayment: {
        sum: '',
        purpose: '',
        user_id: null,
        email:''
      },
      isErrorSum: false,
      errorMessageSum: '',
      modeModalSumDialog: 'Сохранить',
      serverTime: {},
      targetPaymentTime: "8:10:00",
      showModalNoteDialog:false,
      note:{
        email:'',
        text:'',
        user_id: null,
      },
      isErrorNote:false,
      errorMessageNote:'',
      selectedStatus: null,
      listOfStatuses: []
    };
  },
  computed: {
    dateTimePeriod() {
      return this.choosenPeriod[0] + ' ' + '~' + this.choosenPeriod[1];
    },
    disabledButtonForPayed() {
      return  (this.currentWeek === this.selectedFilter.week && (new Date()).getFullYear() === this.selectedFilter.year) || this.sortedData[this.choosenRole].some(item=> item.status === true);
    },
    selectAll: {
      get: function () {
        return this.select_to_pay ? this.select_to_pay.length === this.requestedUsers.length : false;
      },
      set: function (value) {
        var selected = [];

        if (value) {
          this.requestedUsers.forEach(function (user) {
            selected.push(user);
          });
        }

        this.select_to_pay = selected;
      }
    },
    showPayedButton() {
      return this.selectedStatus !== null;
    },
  },
  watch: {
    selectedWeek: function (val) {
      this.getRangeOfWeek();
      this.saveToLocalStorage('selectedWeek');
    },
    choosenRole() {
      this.saveToLocalStorage('choosenRole');
    },
    reportedUsers(){
      this.saveToLocalStorage('reportedUsers');
    },
    selectedYear(){
      this.saveToLocalStorage('selectedYear');
    }
  },
  methods: {
    async showUserSelect() {
      this.loading = !this.loading;
      this.chosenUsers = [];
     // this.reportedUsers = this.reportedUsers ?? [];
      this.reportedUsers = [];
      this.sortedData = [];
      this.sortedPayed = [];
      try {
        await this.$store.dispatch("users/chosenRolesUsersList", {roles: [this.choosenRole]});
        let data = await this.$store.getters['users/chosenRolesUsersList'];
        let local_page_keys = this.local_page_keys;
        this.chosenUsers = Object.values(data).sort((a, b) => (a.role > b.role) ? 1 : ((b.role > a.role) ? -1 : 0))
            .reduce(function (total, item, index, array) {
              if (!array[index - 1] || (array[index - 1].role && array[index - 1].role !== item.role)) {
                let key = 'all_' + item.role + "s";
                total.push({
                  email: local_page_keys[key],
                  name: 'all',
                  group: true,
                  id: 'all',
                })
              }
              total.push(item);
              return total;
            }, []);
        // this.chosenUsers.unshift(
        //     {
        //       email: 'ALL',
        //       name: '',
        //       group: true,
        //       id: 'all'
        //     });
        this.loading = !this.loading;
      } catch (e) {
        this.loading = !this.loading;
        alert(this.local_page_keys.alert_failed_salary_data)
      }
    },
    async showUserSelectForWeek() {
      if (this.choosenRole.includes('all')) {
        for (let role of this.roles) {
          if (!this.choosenRole.includes(role.value)) this.choosenRole.push(role.value)
        }
      }

      this.loading = !this.loading;
      this.chosenUsers = [];
      this.reportedUsers = [];
      this.sortedData = [];
      this.sortedPayed = [];
      try {
        let roles = this.choosenRole;
        if (roles.includes('all')) {
          roles.splice(roles.indexOf('all'), 1)
        }
        await this.$store.dispatch("users/chosenRolesUsersList", {roles});
        let data = await this.$store.getters['users/chosenRolesUsersList'];
        this.chosenUsers = data;
        this.loading = !this.loading;
      } catch (e) {
        this.loading = !this.loading;
        alert(this.local_page_keys.alert_failed_salary_data)
      }

    },
    getPeriod() {
      this.choosenPeriod.sort();
    },
    getRolesList() {
      if (this.choosenRole.includes('all')) {
        return ['retoucher', 'pro-retoucher', 'junior-retoucher']
      }
      return this.choosenRole;
    },
    getUsersGroupeList(role) {
      let usersOfRole = [];
      for (let user of Object.values(this.chosenUsers)) {
        if (user.role === role) {
          usersOfRole.push(user)
        }
      }
      return usersOfRole;
    },
    showUserslist() {
      this.selectedStatus = null;
      if (this.reportedUsers[0] === 'all' && this.reportedUsers.length > 1 ) {
        const allIndex = this.reportedUsers.indexOf('all');
        if (allIndex !== -1) {
          this.reportedUsers.splice(allIndex, 1);
        }
      }
      if (this.reportedUsers.includes('all')) {
        this.reportedUsers = ['all'];
        this.selectedStatus = 'active';
      }
    },
    getAllOfRoles(role) {
      let users = this.getUsersGroupeList(role)
      let allUsers = [];
      for (let user of Object.values(users)) {
        allUsers.push(user.id)
      }
      return allUsers;
    },
    async getReport() {
      this.sortedData = [];
      this.sortedPayed = [];
      this.select_to_pay = [];
      let formData = new FormData();
      for (let role of this.getRolesList()) {
        if (this.reportedUsers.includes(role)) {
          this.reportedUsers.splice(this.reportedUsers.indexOf(role), 1)
        }
      }
      this.requestedUsers = this.reportedUsers;
      this.prepareUsersList();

      // formData.append('start_date', this.choosenPeriod[0] + ' ' + this.startTime);
      // formData.append('end_date', this.choosenPeriod[1] + ' ' + this.endTime);
      formData.append('week', this.selectedWeek.week);
      formData.append('year', this.selectedWeek.year);
      formData.append('role', this.choosenRole);
      formData.append('withAdditionalPayment', true);

      for (let i = 0; i < this.requestedUsers.length; i++) {
        formData.append('users_ids[' + i + ']', this.requestedUsers[i]);
      }

      this.loading = true;
      try {
        await this.$store.dispatch("salary/reportSalaryData", formData);
        let data = await this.$store.getters['salary/reportSalaryData'];
        this.sortedData = data.users;
        this.selectedFilter.week = this.selectedWeek.week;
        this.selectedFilter.year = this.selectedWeek.year;
        this.loading = false;
      } catch (e) {
        alert(this.local_page_keys.alert_failed_salary_data);
        this.loading = false;
      }
    },
    async getExcelReport() {
      let formData = new FormData();
      for (let role of this.getRolesList()) {
        if (this.reportedUsers.includes(role)) {
          this.reportedUsers.splice(this.reportedUsers.indexOf(role), 1)
        }
      }
      this.requestedUsers = this.reportedUsers;
      this.prepareUsersList();

      formData.append('week', this.selectedWeek.week);
      formData.append('year', this.selectedWeek.year);
      formData.append('role', this.choosenRole);
      formData.append('withAdditionalPayment', true);

      for (let i = 0; i < this.requestedUsers.length; i++) {
        formData.append('users_ids[' + i + ']', this.requestedUsers[i]);
      }

      this.loadingExport = true;
      try {
        await this.$store.dispatch("salary/reportExcelSalaryData", formData);
        let response = await this.$store.getters['salary/reportExcelSalaryData'];

        // console.log(response)
        const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = this.selectedWeek.year + '_' + this.selectedWeek + '_' + this.choosenRole + '_report.xlsx';
        link.click();
        window.URL.revokeObjectURL(url);

      } catch (e) {
        alert(this.local_page_keys.alert_failed_salary_data);

      }
      this.loadingExport = false;

    },
    getHeaders(data) {
      let headers = [];
      switch (data) {
        case 'retoucher':
          headers = [
            {
              text: this.local_page_keys.table_head_user_name,
              value: 'user_name'
            },
            {
              text: this.local_page_keys.table_head_user_role,
              value: 'user_role'
            },
            {
              text: this.local_page_keys.table_head_orders_count,
              value: 'orders_count',
            },
            {
              text: this.local_page_keys.table_head_total_orders_price,
              value: 'total_orders_price',
            },
            {
              text: this.local_page_keys.table_head_clients_tips,
              value: 'clients_tips',
            },
            {
              text: this.local_page_keys.table_head_all_amount,
              value: 'all_amount',
            },
          ];
          break;
        case 'junior-retoucher':
          headers = [
            {
              text: this.local_page_keys.table_head_user_name,
              value: 'user_name'
            },
            {
              text: this.local_page_keys.table_head_user_role,
              value: 'user_role'
            },
            {
              text: this.local_page_keys.table_head_orders_count,
              value: 'orders_count',
            },
            {
              text: this.local_page_keys.table_head_total_orders_price,
              value: 'total_orders_price',
            },
            {
              text: this.local_page_keys.table_head_clients_tips,
              value: 'clients_tips',
            },
            {
              text: this.local_page_keys.table_head_all_amount,
              value: 'all_amount',
            },
          ];
          break;
        case 'pro-retoucher':
          headers = [
            {
              text: this.local_page_keys.table_head_user_name,
              value: 'user_name'
            },
            {
              text: this.local_page_keys.table_head_user_role,
              value: 'user_role'
            },
            {
              text: this.local_page_keys.table_head_orders_count,
              value: 'orders_count',
            },
          ];
          break;
        case 'senior-retoucher':
          headers = [
            {
              text: this.local_page_keys.table_head_user_name,
              value: 'user_name'
            },
            {
              text: this.local_page_keys.table_head_user_role,
              value: 'user_role'
            },
            {
              text: this.local_page_keys.table_head_count_bad_job,
              value: 'count_bad_job',
            },
            {
              text: this.local_page_keys.table_head_count_nice_job,
              value: 'count_nice_job',
            },
            {
              text: this.local_page_keys.table_head_orders_count,
              value: 'orders_count',
            },
          ];
          break;

      }
      return headers;

    },
    customSort() {
      return false;
    },
    showTimePeriod() {
      setTimeout(() => {
        this.showDateRangePiecker = !this.showDateRangePiecker;
      }, 500)
    },
    thisRoleSelected(data) {
      for (let item of data) {
        if (this.select_to_pay.includes(item.user_id)) {
          return true;
        }
      }
      return false;
    },
    async writePayedRetouchers() {
      await this.fetchServerTime();
      if (! this.allowOperationByTime()) {
        alert('Выплаты разрешены только после ' + this.targetPaymentTime +' GMT+3');
      }
      else {
        if (confirm(this.local_page_keys.confirm_mark_as_payed)) {
          this.loadingPayment = true;
          let formdata = new FormData();
          let users = [];
          // formdata.append('date_start', this.choosenPeriod[0]);
          // formdata.append('date_end', this.choosenPeriod[1]);
          formdata.append('year', this.selectedWeek.year);
          formdata.append('week', this.selectedWeek.week);
          formdata.append('withAdditionalPayment', true);


          // for (let i = 0; i < this.select_to_pay.length; i++) {
          //   formdata.append('user_ids[' + i + ']', this.select_to_pay[i]);
          // }

          if (this.reportedUsers.includes('all')) {
            users = this.chosenUsers.map(user => user.id).filter(user_id => user_id !== 'all');

            for (let i = 0; i < users.length; i++) {
              formdata.append('user_ids[' + i + ']', users[i]);
            }
          } else return;

          await this.$store.dispatch('salary/writePayedRetouchers', formdata);
          let data = await this.$store.getters['salary/writePayedRetouchers'];
          if (data.status === 'ok') {
            //this.reportedUsers = [this.requestedUsers];
            this.reportedUsers = ['all'];
            await this.getReport();
            let message = "Оплата за " + this.selectedWeek.week + ' неделю ' + '(' + this.rangeOfWeek + ')' + ' для ' + this.choosenRole + ' завершена успешно!';
            alert(message);
          } else if (data.status === 'error') {
            alert(data.message);
          }
          this.loadingPayment = false;
        }
      }
    },
    allowOperationByTime() {
      const responseHourInt = parseInt(this.serverTime.hour, 10);
      const responseMinuteInt = parseInt(this.serverTime.minutes, 10);
      const [targetHour, targetMinute] = this.targetPaymentTime.split(":");
      const targetHourInt = parseInt(targetHour, 10);
      const targetMinuteInt = parseInt(targetMinute, 10);

      if (responseHourInt > targetHourInt || (responseHourInt === targetHourInt && responseMinuteInt >= targetMinuteInt)) {
        return true
      }
      return false;
    },
    clearDatas() {
      this.sortedPayed = [];
      this.sortedData = [];
    },
    async getListByRoles() {
      let roles = this.roles;
      let listByRoles = {};
      for (const element of roles) {
        await this.$store.dispatch("users/chosenRolesUsersList", {roles: [element.value]});
        listByRoles[element.text] = await this.$store.getters['users/chosenRolesUsersList'];
      }
      this.listByRoles = listByRoles;
    },
    async showWeekRole() {

      let _this = this;
      if (null == this.roleForWeek) {
        return
      }
      await this.getListByRoles();
      // this.showWeek=false
      // this.loadingWeek=true
      let listForWeek = [];
      listForWeek = this.listByRoles[this.roleForWeek]
      let userIds = []
      Object.entries(listForWeek).forEach(([key, value]) => {
        userIds.push(value.id);
      });

      let weekData = await this.getWeekData();
      userIds.forEach(value => {
        let a = weekData.find(wd => wd.user_id === value
            && (_this.usedWeek.year).toString() === (wd.year).toString()
            && (_this.usedWeek.number).toString() === (wd.num_week).toString()
        );

        if (a === undefined) {
          //return;
          listForWeek[value].sum_week = '';
          listForWeek[value].sum_downtime = '';
        } else {
          listForWeek[value].sum_week = a.sum_week != 'null' ? a.sum_week : '';
          listForWeek[value].sum_downtime = a.sum_downtime != 'null' ? a.sum_downtime : '';
        }
        listForWeek[value].sum_week_isValid = true;
        listForWeek[value].sum_week_lastValid = listForWeek[value].sum_week;
        listForWeek[value].sum_downtime_isValid = true;
        listForWeek[value].sum_downtime_lastValid = listForWeek[value].sum_downtime;
        listForWeek[value].check = true;

      });

      this.listForWeek = listForWeek;
      this.listForWeekCheckAll = true;

      //console.log(listForWeek);
    },
    async getWeekData() {
      let formData = new FormData();
      formData.append('week', this.usedWeek.number);
      await this.$store.dispatch("salary/getWeekData", formData);
      this.getterKey++;

      return await this.$store.getters['salary/getWeekData'](this.getterKey);
    },
    async saveWeekData() {
      this.loadingWeek = true;
      if (Object.keys(this.listForWeek).length > 0) {
        let result = await this.saveWeekDataToDb();
        if (!result.hasOwnProperty('error')) {
          UIkit.notification({message: 'Данные сохранены!', pos: 'top-center', status: 'success', timeout: 1500});
        } else {
          UIkit.notification({
            message: 'Данные не сохранены!' + ' ' + String(result.error),
            pos: 'top-center',
            status: 'warning',
            timeout: 1500
          });
        }
      }
      this.loadingWeek = false;
    },
    async saveWeekDataToDb() {
      if (Object.keys(this.listForWeek).length > 0) {
        let formData = new FormData();
        let rowCounter = 0;
        let rowIsValid = true;
        for (let row in this.listForWeek) {

          if (this.listForWeek[row].check === true) {
            for (let col in this.listForWeek[row]) {
              formData.append('data[' + row + '][' + col + ']', this.listForWeek[row][col]);
              if (col.indexOf('_isValid') > -1 && this.listForWeek[row][col] !== true) {
                rowIsValid = false;
              }
            }
            formData.append('data[' + row + '][user_id]', this.listForWeek[row]['id']);
            formData.append('data[' + row + '][num_week]', this.usedWeek['number']);
            formData.append('data[' + row + '][year]', this.usedWeek['year']);
          }
          rowCounter++;
        }

        if (!rowIsValid) return {error: 'Проверьте вводные данные, могут быть минусы'}
        if (rowCounter == 0) return {error: 'Отметьте хотя бы один CheckBox'}
        await this.$store.dispatch("salary/storeWeek", formData);

        return await this.$store.getters['salary/storeWeek']
      }
    },
    async chooseWeek(week) {
      await this.useWeek(week.number, week.first, week.last, week.year);
      await this.showWeekRole();
      this.usedWeekNumber = week.number;
      //console.log(week);
    },
    useWeek(number, first, last, year) {
      this.usedWeek['number'] = number;
      this.usedWeek['first'] = first;
      this.usedWeek['last'] = last;
      this.usedWeek['year'] = year;
    },
    getListOfWeeks() {
      let date = new Date();
      let year = date.getFullYear();
      let numOfWeeks = this.getNumOfWeeks(year);
      let weeks = {};
      const options = {day: '2-digit', month: '2-digit', year: 'numeric'};
      for (let i = 1; i <= round(numOfWeeks); i++) {
        let daysOfWeek = this.getDaysOfWeek(i, year);
        let first = new Date(daysOfWeek.shift());
        let last = new Date(daysOfWeek.pop());
        const formattedDateFirst = first.toLocaleDateString('en-GB', options).replace(/\//g, '.');
        const formattedDateLast = last.toLocaleDateString('en-GB', options).replace(/\//g, '.');
        let week = {};
        week['title'] = 'title: ' + formattedDateFirst + " - " + formattedDateLast;
        week['first'] = formattedDateFirst;
        week['last'] = formattedDateLast;
        week['number'] = i;
        week['year'] = year;
        weeks[i] = week;
      }

      this.weeks = weeks;
      this.sortListOfWeeksFromUsedWeekNumber();
      let week = weeks[1];
      this.useWeek(week.number, week.first, week.last, week.year);
    },
    sortListOfWeeksFromUsedWeekNumber() {
      let _this = this;
      let leftObj = {};
      let rightObj = {};
      if (this.usedWeekNumber > 1) {
        let leftObjIter = 1;
        let rightObjIter = 1;
        Object.keys(this.weeks).forEach(key => {
          if (_this.weeks[key].number >= _this.usedWeekNumber) {
            rightObj[Number(rightObjIter) + Number(_this.usedWeekNumber)] = (_this.weeks[key]);
            rightObjIter++;
          }
          if (_this.weeks[key].number < _this.usedWeekNumber) {
            leftObj[leftObjIter] = (_this.weeks[key]);
            leftObjIter++;
          }
        });
        if (Object.keys(rightObj).length > 0) this.weeksLeft = rightObj;
        if (Object.keys(leftObj).length > 0) this.weeksRight = leftObj;
      }
    },
    getNumOfWeeks(year) {
      var startDateOfYear = new Date(year, 0, 1);

      var daysOfYear =
          (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0 ? 366 : 365;

      var daysToNextSunday = (7 - startDateOfYear.getDay()) % 7;

      var daysFromPrevSaturday = startDateOfYear.getDay();

      var daysAfterLastSunday = (daysOfYear - daysToNextSunday) % 7;

      return (daysOfYear - daysToNextSunday - daysFromPrevSaturday - daysAfterLastSunday) /
          7 +
          (daysToNextSunday >= daysFromPrevSaturday ? 1 : 0);
    },
    getDaysOfWeek(weekNumber, year) {
      const date = new Date(year, 0, 1 + (weekNumber - 1) * 7);
      const days = [];
      for (let i = 0; i < 7; i++) {
        const day = new Date(date.getFullYear(), date.getMonth(), date.getDate() + i);
        days.push(day);
      }
      return days;
    },
    getCurrentWeekNumber() {
      const now = new Date();
      const startOfYear = new Date(now.getFullYear(), 0, 1);
      const millisecondsPerWeek = 7 * 24 * 60 * 60 * 1000;
      const millisecondsSinceStartOfYear = now - startOfYear;
      let currentWeek = Math.ceil(millisecondsSinceStartOfYear / millisecondsPerWeek);
    //  this.usedWeekNumber = currentWeek;
      //this.selectedWeek = currentWeek;
      //this.selectedWeek = this.listOfWeeks.find(week => week.week ===  currentWeek && week.year === this.selectedYear);
      this.selectedWeek = this.listOfWeeks.find(week => week.current);
      //this.currentWeek = currentWeek;
    },
    async showCurrentWeekNumber() {
      this.usedWeek = JSON.parse(JSON.stringify(this.weeks[this.usedWeekNumber]));
      let index = this.usedWeekNumber;
      this.activeElement = index;
      this.$nextTick(() => {
        const switcher = UIkit.switcher(this.$refs.weekSwitcher);
        switcher.show(index);

        //this.scrollToElement(index);
      });
    },
    scrollToElement(index) {
      const element = this.$refs.weekSwitcher.children[Number(index)];
      if (element) {
        element.scrollIntoView({
          behavior: 'auto',
          block: 'center',
          inline: 'start'
        });
      }
    },
    changeTab(tab) {
      this.activeTab = tab;
      this.select_to_pay = [];
    },
    showField(role, field) {
      return this.fields[role] && this.fields[role].indexOf(field) >= 0;
    },
    async changeYear() {
      await axios.get(`${url}/salary/get_weeks/` + this.selectedYear).then(response => {
        this.listOfWeeks = response.data;
        //this.selectedWeek = this.listOfWeeks.find(week => week.week === this.currentWeek && week.year === this.selectedYear) ;
        this.selectedWeek = this.listOfWeeks.find(week => week.current);
      });
    },
    getRangeOfWeek() {
      // let selectedWeek = this.listOfWeeks.filter(week => week.week === this.selectedWeek);
      // selectedWeek = selectedWeek && selectedWeek[0] ? selectedWeek[0] : null;
      // this.rangeOfWeek = selectedWeek ? selectedWeek.start_of_week + " - " + selectedWeek.end_of_week : "";
      this.rangeOfWeek = this.selectedWeek ? this.selectedWeek.start_of_week + " - " + this.selectedWeek.end_of_week : "";
    },
    async onSortBy(data) {
      let column = data.column;
      let order = data.order;
      if (this.sortBy.column === column) {
        this.sortBy.order = order === 'desc' ? 'asc' : 'desc';
      } else {
        this.sortBy.column = column;
        this.sortBy.order = order;
      }
      let actualSort = this.sortBy;
      this.sortedData[this.choosenRole].sort((a, b) => {
            let firstValue = a[actualSort.column];
            let secondValue = b[actualSort.column];
            if (actualSort.order === 'asc') {
              return (firstValue > secondValue ? 1 : ((secondValue > firstValue) ? -1 : 0));
            } else {
              return (firstValue < secondValue) ? 1 : ((secondValue < firstValue) ? -1 : 0)
            }
          }
      )
    },
    modalSumDialog(mode,data) {
      if (data.additional_payment !== null) {
        this.additionalPayment = {
          sum: data.additional_payment === 0 ? '' : data.additional_payment,
          purpose: data.additional_payment_purpose,
          user_id: data.user_id,
          email:data.email
        };
      }
      else {
        this.additionalPayment = {
          user_id: data.user_id,
          email: data.email
        };
      }
      //
      // if (mode === 'create')
      //   this.modeModalSumDialog = 'Создать';
      // else if (mode === 'edit')
      //   this.modeModalSumDialog = 'Сохранить';

      this.isErrorSum = false;
      this.errorMessageSum = '';
      this.showModalSumDialog = true;
    },
    closeModalSumDialog() {
      this.showModalSumDialog = false;
      this.additionalPayment = {
        sum: '',
        purpose: '',
        user_id: null,
        email:''
      };
    },
    columnSum(field) {
      let sum = 0;
      if (this.sortedData[this.choosenRole]) {
        sum = Object.values(this.sortedData[this.choosenRole]).reduce((accumulator, currentValue) => {
          // Проверяем, существует ли currentValue[field] и является ли числом
          if (field === 'additional_payment.payment') {
            if (currentValue.additional_payment && typeof currentValue.additional_payment.payment === 'number') {
              return accumulator + currentValue.additional_payment.payment;
            } else {
              return accumulator;
            }
          } else if (typeof currentValue[field] === 'number') {
            return accumulator + currentValue[field];
          } else {
            return accumulator;
          }
        }, 0);
      }
      return Math.round(sum);
    },
    async saveAdditionalPayment() {
      if (isNaN(this.additionalPayment.sum)) {
        this.isErrorSum = true;
        this.errorMessageSum = 'Значение суммы должно быть числом.';
      } else if (this.additionalPayment.sum === '') {
        this.isErrorSum = true;
        this.errorMessageSum = 'Значение суммы обязательно для заполнения';
      } else if (this.additionalPayment.sum < 0 ) {
        this.isErrorSum = true;
        this.errorMessageSum = 'Значение суммы должно быть положительным числом';
      } else if(!Number.isInteger(Number(this.additionalPayment.sum))) {
        this.isErrorSum = true;
        this.errorMessageSum = 'Значение суммы должно быть целым числом';
      } else {
        this.isErrorSum = false;
        this.errorMessageSum = '';

        let formData = new FormData();
        formData.append('user_id',this.additionalPayment.user_id);
        formData.append('week', this.selectedWeek.week);
        formData.append('year', this.selectedWeek.year);
        formData.append('payment', this.additionalPayment.sum);
        formData.append('purpose', this.additionalPayment.purpose);

        await this.$store.dispatch("salary/storeAdditionalPayment", formData);
        let result =  await this.$store.getters['salary/storeAdditionalPayment'];

        if (!result.hasOwnProperty('errors')) {
          UIkit.notification({message: 'Данные сохранены!', pos: 'top-center', status: 'success', timeout: 1500});
          this.modeModalSumDialog = 'Сохранить';
          this.getReport();
          // const retouchers = this.sortedData[this.choosenRole];
          // for (let i = 0; i < retouchers.length; i++) {
          //   if ( Number(retouchers[i].user_id) === Number(result.additional_payment_data.user_id)) {
          //     retouchers[i].additional_payment = result.additional_payment_data;
          //     break;
          //   }
          // }
        } else {
          UIkit.notification({
            message: 'Данные не сохранены!' + ' ' + String(result.errors),
            pos: 'top-center',
            status: 'warning',
            timeout: 1500
          });
        }
      }
    },
    modalNoteDialog(mode,data){
      if (data.note !== null) {
        this.note = {
          text: data.note,
          user_id: data.user_id,
          email:data.email
        };
      }
      else {
        this.note = {
          user_id: data.user_id,
          email: data.email,
          text: ''
        };
      }

      this.isErrorNote = false;
      this.errorMessageNote = '';
      this.showModalNoteDialog = true;
    },
    async saveNote() {
      if (!this.note.text || this.note.text === '') {
        this.isErrorNote = true;
        this.errorMessageNote = 'Поле для заметки обязательно для заполнения';
      } else {
        this.isErrorNote = false;
        this.errorMessageNote = '';
      }

      let formData = new FormData();
      formData.append('user_id', this.note.user_id);
      formData.append('note', this.note.text);

      await this.$store.dispatch("salary/storeNote", formData);
      let result = await this.$store.getters['salary/storeNote'];

      if (!result.hasOwnProperty('errors')) {
        UIkit.notification({message: 'Данные сохранены!', pos: 'top-center', status: 'success', timeout: 1500});
        this.getReport();

      } else {
        UIkit.notification({
          message: 'Данные не сохранены!' + ' ' + String(result.errors),
          pos: 'top-center',
          status: 'danger',
          timeout: 1500
        });
      }
    },
    closeModalNoteDialog() {
      this.showModalNoteDialog = false;
      this.note = {
        user_id: null,
        text: '',
        email:'',
      };
    },
    async fetchServerTime() {
      try {
        await this.$store.dispatch("schedule/scheduleValidateTime");
        this.getterKey++;
        const response = await this.$store.getters["schedule/scheduleValidateTime"](this.getterKey);
        if(response.linuxTimestamp){
          this.serverTime = response;
        }
      } catch (error) {
        alert('Error fetching server time:' + error);
      }
    },
    prepareUsersList(){
      if (this.selectedStatus === 'all') {
        this.requestedUsers = this.chosenUsers.map(user => user.id).filter(user_id => user_id !== 'all');
      } else if (this.selectedStatus === 'active') {
        this.requestedUsers = this.chosenUsers.filter(function(user) {
          return user.deleted === false;
        }).map(user => user.id);
      } else if (this.selectedStatus === 'deleted') {
        this.requestedUsers = this.chosenUsers.filter(function(user) {
          return user.deleted === true;
        }).map(user => user.id)
      }
    },
    initListOfStatuses() {
      this.listOfStatuses = [
        {
          value: 'all',
          name: this.local_page_keys.select_users_all
        },
        {
          value: 'active',
          name: this.local_page_keys.select_users_active
        },
        {
          value: 'deleted',
          name: this.local_page_keys.select_users_deleted
        },
      ]
    },
    getTooltipData(item, field) {
      let tooltipName = 'tooltip_data_' + field;
      return item.tooltip_data[tooltipName];
    },
    getNumberFromEmail(email){
      if(email){
        if(email.match(/(\d+)(?=(.)*@)/) !== null){
          if( email.match(/(\d+)(?=(.)*@)/)[0]){
            return email.match(/(\d+)(?=(.)*@)/)[0];
          }
        }
        return email.charAt(0);
      }
      return email;
    },
  },
  async mounted() {
    this.local_page_keys = Object.assign({}, await this.$filtergetLocalisationPage('salary'), await this.$filtergetLocalisationPage('users-page'));
    await this.$store.dispatch('salary/defaultPeriod');
    let defaultPeriod = await this.$store.getters['salary/defaultPeriod'];
    this.choosenPeriod.push(defaultPeriod.start_date.slice(0, 10))
    this.choosenPeriod.push(defaultPeriod.end_date.slice(0, 10))
    this.usedWeekNumber = defaultPeriod.current_week;
    this.currentWeek = defaultPeriod.current_week;
    this.selectedYear = defaultPeriod.current_year;
    this.endTime = (defaultPeriod.end_date.slice(-6, -3) + ':00').trim();
    let today = new Date().toJSON();
    this.todayDate = today.slice(0, today.indexOf('T'));
    await this.changeYear();
    await this.getCurrentWeekNumber();

    //  await this.getListByRoles();
    this.getListOfWeeks();
    await this.showCurrentWeekNumber();
    this.roleForWeek = this.roles[0].text;
    await this.showWeekRole();
    this.initListOfStatuses();

    this.loadFromLocalStorage('selectedWeek', 'choosenRole','reportedUsers','selectedYear');
    if (this.reportedUsers.length > 0 ) {
      await this.showUserSelect();
      this.showUserslist();
      await this.getReport();
    }
  },

  beforeDestroy() {
    localStorage.removeItem('Salary2_selectedValues');
  },
}
</script>

<style>
  .tm-salary-header-fix-min-height {
    min-height: 140px;
  }
  .tm-button-edit .md-icon {
    width: 20px;
    min-width: 20px;
    height: 20px;
    font-size: 20px!important;
  }
  .tm-button-edit:hover .md-icon {
    color: #4caf50;
  }
  .tm-salary-table .uk-button.tm-button-add {
    padding: 0;
    line-height: 1;
  }
  .tm-salary-sort > div {
    margin-left: 0 !important;
  }
  .tm-salary-select-tit {
    top: -25px;
    font-size: 13px;
  }
  .tm-bonus-for-schedule {
    background-color: rgb(0 75 255 / 5%);
  }
  .tm-salary-bonus {
    background-color: rgb(0 198 24 / 7%);
  }
  .tm-number-of-orders {
    background-color: rgb(243 69 255 / 5%);
  }
  .tm-additional-payment {
    background-color: rgb(69 248 255 / 5%);
  }
  .tm-number-of-waiting-minutes {
    background-color: rgb(0 179 207 / 6%);
  }
  .tm-whole-sum {
    background-color: rgb(255 0 0 / 4%);
  }
  .tm-cell-user {
    background-color: rgb(255 111 0 / 4%);
  }
  .tm-salary-table .tm-grid-bg-hover:hover:nth-child(2n),
  .tm-salary-table .tm-grid-bg-hover:hover {
    transition: .3s ease-out;
    background-color: #e1e1e1;
  }
  .tm-salary-table .tm-grid-bg-hover:nth-child(2n) {
    background-color: #f5f5f5;
  }
  .tm-salary-slider-items > * {
    width: 100px;
  }
  .tm-salary-slider-items a.tm-active {
    transition: .3s ease-out;
  }
  .tm-salary-slider-items li.uk-active a,
  .tm-salary-slider-items li.uk-active a:hover,
  .tm-salary-slider-items a.tm-active,
  .tm-salary-slider-items a:hover {
    background-color: transparent;
  }
  .tm-salary-slider-items li a {
    background-color: transparent;
  }
  .tm-salary-slider-items li.tm-active-week a,
  .tm-salary-slider-items li a:hover,
  .tm-salary-slider-items li.tm-active-week a:hover {
    background-color: #3b8e3f !important;
  }
  .tm-salary-slider-items.uk-grid-divider > :not(.uk-first-column):before {
    border-left: 1px solid #429d47;
  }
  .uk-button.tm-button-success {
    background-color: #4caf50;
    color: #fff !important;
  }
  .uk-button.tm-button-success:hover {
    background-color: #3b8e3f;
    color: #fff !important;
  }
  .v-progress-circular {
    display: block;
    width: 100px;
    margin: 0 auto;
  }
  /*.v-date-picker-table .v-btn.v-btn--active {*/
  /*  color: green;*/
  /*}*/
  /*.weekpicker {*/
  /*  padding: 1px;*/
  /*  padding-top: 1em;*/
  /*}*/
  /*.tm-salary-table .md-table-head-container,*/
  /*.tm-salary-table .md-table-head-label {*/
  /*  white-space: inherit;*/
  /*}*/
  /*.tm-salary-table .md-table-head-label,*/
  /*.tm-salary-table table tr * {*/
  /*  font-size: 12px;*/
  /*  line-height: 1.4em;*/
  /*}*/
  /*.tm-salary-table .md-table-head,*/
  /*.tm-salary-table table tr * {*/
  /*  padding: 6px;*/
  /*}*/
  /*.tm-salary-table .md-table-head-container,*/
  /*.tm-salary-table .md-table-head-label,*/
  /*.tm-salary-table table tr * {*/
  /*  height: auto;*/
  /*}*/
  /*.tm-salary-table .md-table-head-label,*/
  /*.tm-salary-table table tr * {*/
  /*  text-align: center;*/
  /*}*/
  /*.tm-salary-table table tbody tr td:first-child > * {*/
  /*  text-align: left;*/
  /*}*/
  /*.tm-salary-table table tr td > *,*/
  /*.tm-salary-table .md-table-head-label,*/
  /*.tm-salary-table .md-table-head-container {*/
  /*  padding: 0;*/
  /*}*/
  /*.tm-salary-table .md-table-head-label {*/
  /*  display: block;*/
  /*}*/
  /*.tm-salary-table .md-table-head:last-child:not(:first-child) .md-table-head-label {*/
  /*  padding-right: 0;*/
  /*}*/
  /*.tm-salary-table.md-table .md-table-row:hover .md-table-cell {*/
  /*  background-color: rgba(0, 0, 0, .08) !important;*/
  /*}*/
  /*.tm-salary-table table tr th,*/
  /*.tm-salary-table table tr td {*/
  /*  width: 8%;*/
  /*}*/
  /*.tm-salary-table table tr th:first-child,*/
  /*.tm-salary-table table tr td:first-child {*/
  /*  width: 12%;*/
  /*}*/
  /*.md-datepicker-dialog .v-picker__title {*/
  /*  display: none;*/
  /*}*/
</style>